export const SN_WEBHOOK = 'webhook'
export const WEBHOOK_UPDATED = SN_WEBHOOK + '/WEBHOOK_UPDATED'